import { useEffect, useState } from "react";
import { Card, ListGroup } from "react-bootstrap";
import { UsersOverview } from "../../../types/UserAdmin/UsersOverview";
import { useUserAdminService } from "../../../hooks";

const UserOverview = () => {
  const [userOverview, setUserOverview] = useState<UsersOverview>();
  const userAdminService = useUserAdminService();

  useEffect(() => {
    userAdminService
      .userOverview()
      .then((response) => {
        setUserOverview(response);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {userOverview && (
        <>
          <h5>User Stats</h5>
          <Card className="mb-2">
            <ListGroup horizontal={true}>
              <ListGroup.Item className="text-center" style={{ width: "50%" }}>
                Registered
                <div className="font-weight-bold" style={{ fontSize: "3rem" }}>
                  {userOverview.registeredUsers}
                </div>
              </ListGroup.Item>
              <ListGroup.Item className="text-center" style={{ width: "50%" }}>
                Recently Active
                <div className="font-weight-bold" style={{ fontSize: "3rem" }}>
                  {userOverview.recentlyActiveUsers}
                </div>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </>
      )}
    </>
  );
};

export default UserOverview;
